import React from "react"
import Image from "gatsby-image"

const largeImage = ({ content }) => {
  const largeImageSrc = {
    fluid: content.imageLarge?.localFile?.childImageSharp?.fluid,
    alt: content.imageLarge?.altText,
  }
  return (
    <div className="py-24">
      <Image
        fluid={largeImageSrc.fluid}
        alt={largeImageSrc.alt}
        className="w-full h-auto"
      />
    </div>
  )
}

export default largeImage
